import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import { displayErrorToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import TopButton from "../../../components/button/top-button/topButton";
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import { employeeListRequest } from '../../../redux/employee/employee.action'
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";

const EmployeeList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const { state } = useLocation()
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { employeeListSuccess, employeeListError } = useSelector(state => state.employee)
    let navigate = useNavigate();
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [emptyFieldCounter, setEmptyFieldCounter] = useState(0)
    const [searchQuery, setSearchQuery] = useState('')

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.EMPLOYEE_LIST, true)
            fetchBusinessList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    const fetchEmployeeList = () => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user)) {
            if (!isEmpty(selectedBusiness)) {
                data.businessId = selectedBusiness.businessId
                data.locationId = selectedLocation.locationId
            }
        }
        if (isLoggedInUserEmployee(user)) {
            data.businessId = employeeSelectedBusiness
            data.locationId = employeeSelectedLocation
        }
        if (!isEmpty(searchQuery)) {
            data.searchQuery = searchQuery
        }
        if (!isEmpty(state) && state.routeType === 'myTeamList') {
            if (isLoggedInUserBusiness(user)) {
                data.supervisorId = user.data.userDetails.userId
                data.supervisorType = user.data.userDetails.userType
            } else if (isLoggedInUserEmployee(user)) {
                data.supervisorId = user.data.userDetails.employeeId
                data.supervisorType = user.data.userDetails.userType
            }
        }
        dispatch(employeeListRequest(data))
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.EMPLOYEE_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.EMPLOYEE_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(employeeListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(employeeListError)) {
            setLoading(false)
        }
    }, [employeeListSuccess, employeeListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
            fetchEmployeeList()
        }
    }, [selectedLocation])

    useEffect(() => {
        if (isLoggedInUserEmployee(user) && !isNull(employeeSelectedBusiness) && !isNull(employeeSelectedLocation)) {
            fetchEmployeeList()
        }
    }, [employeeSelectedBusiness, employeeSelectedLocation])

    const handleAddEmployeeClick = () => {
        navigate(ROUTES.employee.add)
    }

    const handleSearchClick = () => {
        if (isEmpty(searchQuery)) {
            if (Number(emptyFieldCounter) < 3) {
                let currentCounter = emptyFieldCounter
                setEmptyFieldCounter(currentCounter + 1)
                // const data = {}
                // fetchOfferList(data)
                fetchEmployeeList()
            } else {
                displayErrorToast('Please try refreshing the page.')
            }
        } else {
            // const data = {}
            // fetchOfferList(data)
            fetchEmployeeList()
        }
    }

    const handleViewDetail = element => {
        if (isLoggedInUserBusiness(user) && isNull(selectedBusiness) && isNull(selectedLocation)) {
            displayErrorToast('Business and location not selected')
        } else {
            if (state.routeType === 'attendanceList') {
                navigate(ROUTES.attendace.list, {
                    state: {
                        employeeAttendanceList: true,
                        employeeId: element.employeeId,
                        businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                        locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
                    }
                })
            } else if (state.routeType === 'timeOffList') {
                navigate(ROUTES.requests.employeeRequest, {
                    state: {
                        requestorId: element.employeeId,
                        businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                        locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation,
                        requestType: APP_CONSTANTS.EMPLOYEE_REQUEST_TYPE.TIME_OFF
                    }
                })
            } else if (state.routeType === 'payslipList') {
                navigate(ROUTES.payroll.payslipList, {
                    state: {
                        fromRoute: 'employeeList',
                        employeeId: element.employeeId,
                        firstName: element.firstName,
                        lastName: element.lastName,
                        businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                        locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation,
                    }
                })
            } else if (state.routeType === 'myTeamList') {
                navigate(ROUTES.performance.feedbackList, {
                    state: {
                        employeeId: element.employeeId,
                        businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                        locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation,
                    }
                })
            } else if (state.routeType === 'allEmployees' && !isEmpty(state.subActionSecond) && state.subActionSecond === 'viewFeedback') {
                navigate(ROUTES.performance.feedbackList, {
                    state: {
                        employeeId: element.employeeId,
                        businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                        locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation,
                    }
                })
            } else {
                navigate(ROUTES.employee.detail, {
                    state: {
                        employeeId: element.employeeId,
                        businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                        locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
                    }
                })
            }
        }
    }

    const handleViewGoalDetail = element => {
        if (isLoggedInUserBusiness(user) && isNull(selectedBusiness) && isNull(selectedLocation)) {
            displayErrorToast('Business and location not selected')
        } else {
            navigate(ROUTES.performance.goalList, {
                state: {
                    isFromMenu: false,
                    employeeId: element.employeeId,
                    userType: element.userType,
                    businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
                }
            })
        }
    }

    const getActionLabel = () => {
        if (state.routeType === 'attendanceList') {
            return 'View Attendance'
        } else if (state.routeType === 'timeOffList') {
            return 'View Time-Off'
        } else if (state.routeType === 'payslipList') {
            return 'View Payslip'
        } else if (state.routeType === 'myTeamList' || state.routeType === 'allEmployees') {
            return 'View Feedbacks'
        } else {
            return 'View Details'
        }
    }

    return (
        <>
            <CommonScreenContent>
                {/* <div className="mt-2 mb-1">
                    <CommonInputRow> */}
                <ScreenLabel label='Employees' />
                {/* <TopButton label='Add Employee'
                            onClick={() => { handleAddEmployeeClick() }} />
                    </CommonInputRow>
                </div> */}
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                {state.flowType === APP_CONSTANTS.EMPLOYEE_SCREEN_FLOW_TYPE.EMPLOYEES && <div className="ol-search-parent-container">
                    <div className="ol-search-row-parent-container">
                        <div className="ol-search-input-container">
                            <input type="text" className="ol-input-no-border" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search Employee" />
                        </div>
                        <div className="ol-search-icon-container" onClick={() => { handleSearchClick() }}>
                            <img src={require('../../../assets/ic_search_orange.png')} className="img" />
                        </div>
                    </div>
                </div>}

                {!isNull(employeeListSuccess) && !isEmpty(employeeListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Employee Code</th>
                                <th scope="col" className="text-center">Login Code</th>
                                <th scope="col" className="text-center">Personal Email</th>
                                <th scope="col" className="text-center">Mobile</th>
                                <th scope="col" className="text-center">Supervisor</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {employeeListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.firstName} {element.lastName}</td>
                                    <td className="text-center">{element.employeeBusinessMapping[0].employeeCode}</td>
                                    <td className="text-center">{element.employeeBusinessMapping[0].employeeLoginCode}</td>
                                    <td className="text-center">{element.personalEmail}</td>
                                    <td className="text-center">+{element.mobile}</td>
                                    <td className="text-center">{!isEmpty(element.employeeBusinessMapping[0].supervisorDetail) ? `${element.employeeBusinessMapping[0].supervisorDetail.firstName} ${element.employeeBusinessMapping[0].supervisorDetail.lastName}` : '-'}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleViewDetail(element) }}><div className="tr-action-btn">{getActionLabel()}</div></div>
                                            {!isEmpty(state.subAction) && <div className="loc-list-button" onClick={() => { handleViewGoalDetail(element) }}><div className="tr-action-btn">View Goals</div></div>}
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(employeeListError) && <div className="content-error">{employeeListError.message}</div>}
                {state.flowType === APP_CONSTANTS.EMPLOYEE_SCREEN_FLOW_TYPE.EMPLOYEES && state.routeType === 'employeeList' && checkFunctionalityPermission(user, PERMISSION_TYPE.EMPLOYEE, PERMISSION_SUB_TYPE.EMPLOYEE.ADD_EMPLOYEE, employeeSelectedBusiness, employeeSelectedLocation) &&
                    <div className="vl-fab-container" onClick={() => handleAddEmployeeClick()}>
                        <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                    </div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default EmployeeList